import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Id', prop: 'id' },
  { title: 'Program', prop: 'program_id', references: 'admin/programs', referenceProp: 'name' },
  { title: 'Question', prop: 'question_id', references: 'admin/questions', referenceProp: 'question' },
  { title: 'Starting week', prop: 'starting_week_number' },
  { title: 'Stop showing at the start of week', prop: 'ending_week_number' }
]

const filters = [
  { name: 'Filter by program', prop: 'filters.program_id', type: 'autocomplete', references: 'admin/programs', referenceProp: 'name', enabled: true },
  { name: 'Filter by question', prop: 'filters.question_id', type: 'autocomplete', references: 'admin/questions', referenceProp: 'question', enabled: true }
]

const defaults = {
  order: [{ column: 'id', direction: 'desc' }]
}

const Members = (props) => (
  <List
    title='Program Questions'
    apiPath='admin/program_questions'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default Members
